import React, { useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { UserDataContext } from 'context';
import TailwindLayout from 'TailwindcssComponents/TailwindLayout';
import TopBar from 'TailwindcssComponents/TopBar';
import FooterTailwind from 'TailwindcssComponents/Footer';

export default function AddUserRoles() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const { userData } = useContext(UserDataContext);
    const userId = userData && userData.id;
    const firstName = userData && userData.firstName;
    const lastName = userData && userData.lastName;
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const orgName = urlParams.get('orgName') || '';
    const roleName = urlParams.get('roleName') || '';
    const navigate = useNavigate();

    const onSubmit = async () => {
        try {
            const response = await axios.post(`${apiUrl}auth-service/user-role`, { token: token, userId: userId }, {
                headers: { 'Authorization': `Bearer ${bearerToken}` },
            });
            if (response.data?.success) {
                toast.info(response.data.message || 'User Role created successfully');
                navigate('/dashboard');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                throw new Error("Failed to create user role");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
        }
        // finally {
        //     setTimeout(() => {
        //         navigate('/dashboard');
        //     }, 1500);
        // }
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="p-10 min-h-screen">
                <div className="grid grid-cols-1 gap-6">
                    <div className="col-span-1">
                        <p className="text-base font-medium">Hello, {firstName} {lastName} click the button here to accept role invitation as {roleName} of {orgName}.</p>
                        <div className="p-1">
                            <button
                                className="bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
                                onClick={() => onSubmit()}>
                                Accept Invitation
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    );
}